var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            stripe: "",
            "highlight-current-row": "",
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              index: _vm.tableIndex,
              label: _vm.$t("DAStoreList.table.sequence"),
              width: "80",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "rtlSapId",
              label: _vm.$t("DAStoreList.table.customerNumber"),
              "min-width": "140",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "rtlFullName",
              label: _vm.$t("DAStoreList.table.storeName"),
              "min-width": "240",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "empNo",
              label: _vm.$t("DAStoreList.table.SRNO"),
              "min-width": "120",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "empName",
              label: _vm.$t("DAStoreList.table.SRName"),
              "min-width": "120",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "remarkOne",
              label: _vm.$t("DAStoreList.table.remarkOne"),
              "min-width": "160",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "remarkTwo",
              label: _vm.$t("DAStoreList.table.remarkTwo"),
              "min-width": "160",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "remarkThree",
              label: _vm.$t("DAStoreList.table.remarkThree"),
              "min-width": "160",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "errorMsg",
              label: _vm.$t("common.errorInfo"),
              "min-width": "180",
              fixed: "right",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total>0",
          },
        ],
        attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
        on: {
          "update:page": function ($event) {
            _vm.currPage = $event
          },
          "update:limit": function ($event) {
            _vm.limit = $event
          },
          pagination: _vm.fetchData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }